export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },

  setUnreadCount(state, payload) {
    state.unreadCount = payload;
  },

  markNotificationAsRead(state, payload) {
    const notification = payload;
    if (notification && !notification.read) {
      notification.read = true;
      state.unreadCount--;
    }
  },

  addNotification(state, payload) {
    const alreadyExists = state.notifications.some((n) => n.id === payload.id);
    if (alreadyExists) {
      return;
    }

    state.notifications.push(payload);
    if (!payload.read) {
      state.unreadCount++;
    }
  },

  setCurrentNotification(state, notification) {
    state.currentNotification = notification;
  },

  toggleNotificationModal(state, isVisible) {
    state.isNotificationModalVisible = isVisible;
  },

  clearNotifications(state) {
    state.notifications = [];
    state.unreadCount = 0;
    state.currentNotification = null;
  },
};
